
import React from 'react';
import { Button } from '@/components/ui/button';

interface CallToActionProps {
  title: string;
  subtitle: string;
  buttonText: string;
  buttonLink: string;
}

const CallToAction: React.FC<CallToActionProps> = ({ 
  title, 
  subtitle, 
  buttonText, 
  buttonLink 
}) => {
  return (
    <section className="bg-itmgmt-dark-blue text-white section-padding">
      <div className="container-wide text-center">
        <h2 className="heading-lg mb-4">{title}</h2>
        <p className="text-lg max-w-2xl mx-auto mb-8">{subtitle}</p>
        <Button asChild className="button-primary bg-white text-itmgmt-dark-blue hover:bg-gray-100">
          <a href={buttonLink}>{buttonText}</a>
        </Button>
      </div>
    </section>
  );
};

export default CallToAction;
